export type QueryFilterObject = Record<
  string,
  undefined | string | Array<string> | {min?: string; max?: string}
>;
